import { render, staticRenderFns } from "./Appraisals.vue?vue&type=template&id=a1722a84"
import script from "./Appraisals.vue?vue&type=script&lang=js"
export * from "./Appraisals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports